export default "__VITE_ASSET__B1G3WLUu__"